import {
  fetchCreditCardById,
  fetchCreditCardReviewsById,
  fetchPersonalLoanById,
  fetchPersonalLoanReviewsById,
  fetchMarketplaceCreditCards,
  fetchAutoLoanOffers,
} from 'externals/_services/product.service';
import { cleanPopupPaths } from 'helpers/path.helper';
import { wrapService } from 'actions/service_wrapper.actions';
import {
  SELECT_AUTO_LOAN_OFFER_TAB,
  SET_AUTO_LOAN_DETAILS_PURCHASE,
  SET_AUTO_LOAN_DETAILS_REFINANCE,
} from 'types/offersDetails.constants';

const a_fetchCreditCardById = wrapService(fetchCreditCardById, {
  name: 'fetchCreditCardById',
});
const a_fetchCreditCardReviewsById = wrapService(fetchCreditCardReviewsById, {
  name: 'fetchCreditCardReviewsById',
});
const a_fetchPersonalLoanById = wrapService(fetchPersonalLoanById, {
  name: 'fetchPersonalLoanById',
});
const a_fetchPersonalLoanReviewsById = wrapService(
  fetchPersonalLoanReviewsById,
  {
    name: 'fetchPersonalLoanReviewsById',
  },
);
const a_fetchMarketplaceCreditCards = wrapService(fetchMarketplaceCreditCards, {
  name: 'fetchMarketplaceCreditCards',
});
const a_fetchAutoLoanOffers = wrapService(fetchAutoLoanOffers, {
  name: 'fetchAutoLoanOffers',
});

export const creditCardUrlVertical = 'creditCard';
export const personalLoanUrlVertical = 'personalLoan';
export const personalLoanPrequalUrlVertical = 'personalLoanPrequal';
export const autoLoanUrlVertical = 'autoLoan';
export const autoInsuranceVertical = 'autoInsurance';
export const lifeInsuranceVertical = 'lifeInsurance';
export const homeInsuranceVertical = 'homeInsurance';

const getCreditCardDetails = function (offerId, setState, options) {
  return function (dispatch, getState) {
    dispatch(a_fetchCreditCardById(offerId, options))
      .then(creditCardDetails => {
        //WEBNXT-4893 AO experiment
        if (options.applyDefaultApprovalOdds === false) {
          if (
            creditCardDetails &&
            !creditCardDetails.approvalOdds &&
            creditCardDetails.secureCardFlag !== 1
          ) {
            Object.assign(creditCardDetails, { approvalOdds: 'POOR' });
          }
        }
        //end variation changes

        setState(creditCardDetails);
      })
      .catch(error => {
        setState({ error: true, message: error.error });
      });
  };
};

const getCreditCardReviews = function (
  offerId,
  setState,
  numReviews,
  filterCriteria,
) {
  return function (dispatch, getState) {
    dispatch(a_fetchCreditCardReviewsById(offerId, numReviews, filterCriteria))
      .then(creditCardReviews => {
        setState(creditCardReviews);
      })
      .catch(error => {
        setState({ error: true, message: error.error });
      });
  };
};

const getPersonalLoanDetails = function (offerId, setState, creditScore) {
  return function (dispatch, getState) {
    dispatch(a_fetchPersonalLoanById(offerId, creditScore))
      .then(personalLoanDetails => {
        setState(personalLoanDetails);
      })
      .catch(error => {
        setState({ error: true, message: error.error });
      });
  };
};

const getPersonalLoanReviews = function (
  offerId,
  setState,
  numReviews,
  filterCriteria,
) {
  return function (dispatch, getState) {
    dispatch(
      a_fetchPersonalLoanReviewsById(offerId, numReviews, filterCriteria),
    )
      .then(personalLoanReviews => {
        setState(personalLoanReviews);
      })
      .catch(error => {
        setState({ error: true, message: error.error });
      });
  };
};

const getAutoLoanDetails = function (
  productKey,
  setState,
  autoLoanConfig,
  loanAmount,
) {
  return function (dispatch, getState) {
    const queryOptions = Object.assign({}, autoLoanConfig.queryObject, {
      productKey: productKey,
      loanAmount: loanAmount,
    });
    dispatch(a_fetchAutoLoanOffers(queryOptions))
      .then(autoLoanDetails => {
        if (autoLoanDetails.items && autoLoanDetails.items.length > 0) {
          setState(autoLoanDetails.items[0]);
        } else {
          setState({ error: true, message: 'Unable to load auto loan offers' });
        }
      })
      .catch(error => {
        setState({ error: true, message: error.error });
      });
  };
};

export const getSuggestedCreditCards = function (category, setState, offerId) {
  return function (dispatch, getState) {
    if (category) {
      const offerCategory =
        category.charAt(0).toUpperCase() + category.substring(1);
      const queryOptions = { category: offerCategory };
      dispatch(a_fetchMarketplaceCreditCards(queryOptions))
        .then(suggestedCreditCards => {
          if (
            suggestedCreditCards.creditCards &&
            suggestedCreditCards.creditCards.length > 0
          ) {
            suggestedCreditCards.creditCards =
              suggestedCreditCards.creditCards.filter(
                card => card.creditCardId !== offerId,
              );
            setState(suggestedCreditCards);
          }
        })
        .catch(error => {
          setState({ error: true, message: error.error ? error.error : error });
        });
    }
  };
};

const getSuggestedPersonalLoans = function (category, setState, numReviews) {
  return function (dispatch, getState) {
    dispatch(a_fetchPersonalLoanReviewsById(category, numReviews))
      .then(suggestedPersonalLoans => {
        setState(suggestedPersonalLoans);
      })
      .catch(error => {
        setState({ error: true, message: error.error });
      });
  };
};

export const retrieveOfferById = function (
  offerId,
  vertical,
  setState,
  creditScore,
  autoLoanConfig,
  history,
  pathname,
  creditCardConfig,
  loanAmount,
) {
  return function (dispatch, getState) {
    if (vertical === creditCardUrlVertical) {
      dispatch(getCreditCardDetails(offerId, setState, creditCardConfig));
    } else if (vertical === personalLoanUrlVertical) {
      dispatch(getPersonalLoanDetails(offerId, setState, creditScore));
    } else if (vertical === autoLoanUrlVertical && autoLoanConfig) {
      dispatch(
        getAutoLoanDetails(offerId, setState, autoLoanConfig, loanAmount),
      );
    } else {
      history.push(cleanPopupPaths(pathname));
    }
  };
};

export const retrieveReviewsById = function (
  offerId,
  vertical,
  setState,
  numReviews,
  ratingsFilterValue,
  sortingFilterValue,
) {
  return function (dispatch, getState) {
    let filterCriteria =
      sortingFilterValue && sortingFilterValue === 'ASC'
        ? { sort: '-createDate' }
        : {};

    if (ratingsFilterValue && ratingsFilterValue.length > 0) {
      filterCriteria = Object.assign(filterCriteria, {
        rating: ratingsFilterValue.join(','),
      });
    }

    if (vertical === creditCardUrlVertical) {
      dispatch(
        getCreditCardReviews(offerId, setState, numReviews, filterCriteria),
      );
    } else if (vertical === personalLoanUrlVertical) {
      dispatch(
        getPersonalLoanReviews(offerId, setState, numReviews, filterCriteria),
      );
    }
  };
};

export const retrieveSuggestedOffersByCategory = function (
  category,
  vertical,
  setState,
  offerId,
) {
  return function (dispatch, getState) {
    if (vertical === creditCardUrlVertical) {
      dispatch(getSuggestedCreditCards(category, setState, offerId));
    } else if (vertical === personalLoanUrlVertical) {
      dispatch(getSuggestedPersonalLoans(category, setState, offerId));
    }
  };
};

export const validateIdAndVertical = function (offerId, vertical) {
  if (
    offerId &&
    offerId.length > 0 &&
    (vertical === personalLoanUrlVertical ||
      vertical === personalLoanPrequalUrlVertical ||
      vertical === creditCardUrlVertical ||
      vertical === autoLoanUrlVertical ||
      vertical === autoInsuranceVertical ||
      vertical === lifeInsuranceVertical ||
      vertical === homeInsuranceVertical)
  ) {
    return true;
  }
  return false;
};

export const setAutoLoanRefinanceOffersDetails =
  autoLoanOfferDetailRefinance => dispatch => {
    dispatch({
      type: SET_AUTO_LOAN_DETAILS_REFINANCE,
      autoLoanOfferDetailRefinance,
    });
  };

export const setAutoLoanPurchaseOffersDetails =
  autoLoanOfferDetailPurchase => dispatch => {
    dispatch({
      type: SET_AUTO_LOAN_DETAILS_PURCHASE,
      autoLoanOfferDetailPurchase,
    });
  };

export const selectAutoLoanTab = autoLoanOfferTab => dispatch => {
  dispatch({
    type: SELECT_AUTO_LOAN_OFFER_TAB,
    autoLoanOfferTab,
  });
};
